import { jsx as _jsx } from "react/jsx-runtime";
import DisplayNameCell from "./cells/display-name-cell";
import { LastModifiedCell } from "./cells/last-modified-cell";
import { SizeCell } from "./cells/size-cell";
export var getColumnDefinitions = function (allowedActions, actions, i18nStrings, groupByType) {
    return [
        {
            id: "name",
            sortingField: "displayName",
            header: i18nStrings.fileName,
            cell: function (file) {
                return (_jsx(DisplayNameCell, { allowedActions: allowedActions, file: file, actions: actions, i18nStrings: i18nStrings }));
            },
            width: "45%",
            sortingComparator: function (item1, item2) {
                if (!groupByType) {
                    return item1.displayName.localeCompare(item2.displayName);
                }
                // Group by type first and then compare the display names
                if (item1.type === item2.type) {
                    return item1.displayName.localeCompare(item2.displayName);
                }
                // Put folders first in ascending order
                return item1.type === "folder" ? -1 : 1;
            },
        },
        {
            id: "last-modified",
            sortingField: "lastModified",
            header: i18nStrings.fileLastModified,
            cell: function (file) {
                return _jsx(LastModifiedCell, { file: file });
            },
            width: "30%",
        },
        {
            id: "size",
            sortingField: "size",
            header: i18nStrings.fileSize,
            cell: function (file) {
                return _jsx(SizeCell, { file: file });
            },
            width: "25%",
            sortingComparator: function (item1, item2) {
                if (item1.type === "file" && item2.type === "file") {
                    var item1Size = isNaN(Number(item1.size.toString()))
                        ? 0
                        : Number(item1.size.toString());
                    var item2Size = isNaN(Number(item2.size.toString()))
                        ? 0
                        : Number(item2.size.toString());
                    return item1Size - item2Size;
                }
                /*
                 * It doesn't make sense to compare the size of folders and files since
                 * folder doesn't have its own size. So we will group the items by type first
                 * and compare the files size only.
                 */
                return item1.type === "folder" ? -1 : 1;
            },
        },
    ];
};
